import { TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../store";
import { IActualite, setFilteredActualites } from "../store/siteWebSlice";




const SearchBar = () => {


  const dispatch = useDispatch();
  const { actualites } = useSelector((state: IReduxState) => state.siteWeb);


  //hooks
  const theme = useTheme();
  const endesssousDeLg = useMediaQuery(theme.breakpoints.down("lg"));
  const [search, setSearch] = React.useState("");


  const filterFunction = () => {
    if (search.length === 0) {
      dispatch(setFilteredActualites([...actualites]));
    } else {
      const result: any = actualites.filter(
        (item: IActualite, index: number) => {
          const value: any = `${item.titre} ${item.sousTitre} ${item.dateActualite}`;
          return value.toLowerCase().includes(search.toLowerCase());
        }
      );
      dispatch(setFilteredActualites(result));
    }
  };

  React.useEffect(() => {
    filterFunction();
  }, [search]);



  return (
    <Box>
      <TextField
        style={{ marginTop: endesssousDeLg ? 15 : 0 }}
        size="small"
        fullWidth
        label="Rechercher..."
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};
export default SearchBar;
